import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';

import { Observable } from 'rxjs';

@Injectable()
export class BspService {

  private sApiGetPeriodsByCountry = '/api/bsp';
  private sApiActivePeriods = '/active-periods';

  constructor(private httpService: HttpService) {
  }

  public getPeriods(country: string, airline: string) : Observable<Array<string>>{
    return this.httpService.get<string[]>(this.sApiGetPeriodsByCountry + "/" + country + "/" + airline + this.sApiActivePeriods);
  }

}
